const ImageUrls = {
  TRIANGULAR_DOTTED: 'https://cf.quizizz.com/image/triangular-dots.png',
  GOOGLE_CLASSROOM: 'https://cf.quizizz.com/img/icons/lms/google_classroom.png',
  BTS_HEADER_BG_UNION: 'https://cf.quizizz.com/image/union.png',
  TEAM_AMONG_USS: 'https://cf.quizizz.com/img/Explore/team.png',
  FOLDER_OLD_STYLE: 'https://cf.quizizz.com/img/Explore/folder.png',
  SHINING_STAR: 'https://cf.quizizz.com/img/Explore/star.png',
  MAGIC_WAND_ANIMATION: 'https://cf.quizizz.com/image/magic-wand.webp',
  BTS_GIFTS_ANIMATION: 'https://cf.quizizz.com/image/gift-animation.webp',
  BTS_GIFTS_BASKET: 'https://cf.quizizz.com/image/gift-basket.png',
  CHECKMARK_ANIMATED: 'https://cf.quizizz.com/image/check-animated.webp',
  COMMUNITY_WITH_ARROW: 'https://cf.quizizz.com/image/community-rounded.png',
  ICEBREAKER_QUIZ_PAGE: 'https://cf.quizizz.com/image/icebreaker_card_image.png',
  ICEBREAKER_PAGE: 'https://cf.quizizz.com/image/icebreaker_quiz_2.png',
  ICEBREAKER_PAGE_GIF: 'https://cf.quizizz.com/image/QDP-v1.gif',
  ICEBREAKER_PAGE_ROBOT: 'https://cf.quizizz.com/image/ice_breaker_robot.png',
  CREATE_WITH_AI: 'https://cf.quizizz.com/Create%20with%20AI/AI-logomark.png',
  GOOGLE_ICON: 'https://cf.quizizz.com/img/social_media/google.png',
  GOOGLE_DRIVE: 'https://cf.quizizz.com/Create with AI/Static - Google drive.png',
  MAGNIFYING_GLASS: 'https://cf.quizizz.com/img/Explore/MagnifyingGlass.png',
  MICROSOFT_ICON: 'https://cf.quizizz.com/img/social_media/microsoft.png',
  SCHOOL_SUPER_ICON: 'https://cf.quizizz.com/image/school_super_icon.png',
  QUIZIZZ_AI_WORD_MARK: 'https://cf.quizizz.com/image/AI-wordmark%20(1).svg',
  HERO_AI_ANALYZE: 'https://cf.quizizz.com/image/hero_ai_analye.png',
  AI_ANALYZE_EMPTY_SEARCH: 'https://cf.quizizz.com/image/ai_analyze_empty_search.png',
  AI_ANALYZE_ERROR: 'https://cf.quizizz.com/image/analyze_ai_error_2.png',
  AI_ANALYZE_RETRY: 'https://cf.quizizz.com/image/ai_analyze_error.png',
  SCHOOL_ILLU: 'https://cf.quizizz.com/image/2x school illu.png.png', // illu? @Samu
  SCHOOL_LOCK: 'https://cf.quizizz.com/image/school-trial-locked-2x.png',
  QUIZIZZ_LMS_CONNECTION_VERIFIED: 'https://cf.quizizz.com/image/connection_done_512w.png',
  COMPREHENSION_GIF: 'https://cf.quizizz.com/img/Explore/Comprehension_AI_Animation.gif',
  COMPREHENSION_ELA_AI_ZOOMED: 'https://cf.quizizz.com/img/Explore/comprehension-ela-ai-zoomed.gif',
  COMPREHENSION: 'https://cf.quizizz.com/img/Explore/Comprehension.png',
  PARTY_POPPER: 'https://cf.quizizz.com/image/celebration.png',
  PLUG_LOADER: 'https://cf.quizizz.com/image/connection-loader.mp4',
  GCL: 'https://edu.google.com/images/classroom/classroom-icon/hero_logo.png',
  CLEVER_ICON: 'https://cf.quizizz.com/image/Clever-icon-4x.png',
  CLASSLINK_ICON: 'https://cf.quizizz.com/img/logos/classlink-logo.png',
  VOCAB_GRADE_BG: 'https://cf.quizizz.com/image/vocab_grade_bg .png',
  VOCAB_REPORT: 'https://cf.quizizz.com/image/vocab_reports.png',
  VOCAB_SEARCH_PAGE_ENTRY_POINT: 'https://cf.quizizz.com/image/vocab_entry_point_search_page.png',
  VOCAB_EXPLORE_ELA_PAGE_ENTRY_POINT: 'https://cf.quizizz.com/image/explore_page_vocab_entry_point.png',
  RESOURCE_NOT_FOUND: 'https://cf.quizizz.com/image/Group1.png',
  CANVAS_LOGO: 'https://cf.quizizz.com/img/groups/canvas_logo.png',
  SCHOOLOGY_LOGO: 'https://cf.quizizz.com/img/icons/lms/schoology.png',
  COMPREHENSION_EXPLORE: 'https://cf.quizizz.com/img/Explore/comprehension_explore.svg',
  SCROLL: 'https://cf.quizizz.com/image/scroll.png',
  BRAZE_AI_BANNER_ICON: 'https://cf.quizizz.com/image/braze_ai_banner_icon.png',
  BRAZE_BANNER_PREMIUM_ICON: 'https://cf.quizizz.com/image/braze_banner_premium_icon.png',
  BRAZE_BANNER_INFO_ICON: 'https://cf.quizizz.com/image/braze_banner_info_icon.png',
  BRAZE_BANNER_ERROR_ICON: 'https://cf.quizizz.com/image/braze_banner_error_icon.png',
  HEART_ICON: 'https://cf.quizizz.com/img/Explore/heart.png',
  GIFT_BOX: 'https://cf.quizizz.com/image/gift-box.png',
  FEATURE_CHECK_V2: 'https://cf.quizizz.com/image/feature_check_v2.png',
  QUZIZZ_AI_LOGO: 'https://cf.quizizz.com/image/[cm] Brand.png',
  LOCK_UNLOCKED: 'https://cf.quizizz.com/image/unlocked-lock.png',
  MY_LIBRARY_EMPTY_STATE: 'https://cf.quizizz.com/image/emptystate-notfound-my-lib.png',
  MY_LIBRARY_FOOTER_BG: 'https://cf.quizizz.com/image/FC-library-background.png',
  LIB_LIMIT_WARNING_BANNER: 'https://cf.quizizz.com/image/lib_limit_warning.png',
  PREMIUM_RESOURCE_GIF: 'https://cf.quizizz.com/image/premium-resource.mp4',
  IMPORT_CONTENT: 'https://cf.quizizz.com/image/import_content.png',
  IMPORT_CONTENT_DOMAIN: 'https://cf.quizizz.com/image/fc_domain.png',
  IMPORT_CONTENT_GLOBE: 'https://cf.quizizz.com/image/fc_globe.png',
  IMPORT_CONTENT_SLIDES: 'https://cf.quizizz.com/image/fc_slides.png',
  IMPORT_DRIVE: 'https://cf.quizizz.com/img/logos/googleDrive.png',
  IMPORT_MICROSOFT: 'https://cf.quizizz.com/image/microsoft-green.png',
  IMPORT_GOOGLE_FORMS: 'https://cf.quizizz.com/image/forms-purple.png',
  GROWTH_ONBOARDING_EXISTING_USER: 'https://cf.quizizz.com/image/welcome_existing_user.png',
  AI_PAYWALLING_ICON: 'https://cf.quizizz.com/image/ai_paywall_icon.png',
  FFS_US_LOCKED_BANNER: 'https://cf.quizizz.com/image/ffs-us-locked-banner.png',
  FFS_US_UNLOCKED_BANNER: 'https://cf.quizizz.com/image/ffs-us-unlocked-banner-2.png',
  GCSE_HEADER_BRAND: 'https://cf.quizizz.com/image/gcse_header_brand.png',
  GCSE_HEADER_PATTERN: 'https://cf.quizizz.com/image/gcse_header_pattern.png',
  GCSE_QICON: 'https://cf.quizizz.com/image/gcse_qicon.png',
  GCSE_AI: 'https://cf.quizizz.com/image/gcse_ai.png',
  DEMO_QUIZ_BANNER: 'https://cf.quizizz.com/image/demo-quiz-banner.png',
};

export default ImageUrls;
